import type { KeyboardEvent } from 'react';

export function handleEnterKey<T extends Element>(
  event: KeyboardEvent<T>,
  action?: ((event: KeyboardEvent<T>) => void) | (() => void)
) {
  const enterKey = event.key === 'Enter';

  if (enterKey) {
    action?.(event);
  }
}

export const fakeButtonProps = { role: 'button', tabIndex: 0 };
